import classNames from 'classnames';
import { ReactNode } from 'react';

const ContentBlock = ({
  title,
  subtitle,
  name,
  children,
}: {
  title?: string;
  subtitle?: string;
  name?: string;
  children?: ReactNode;
}) => {
  const classes = classNames({
    'content-block': true,
    [`content-block--${name}`]: !!name,
  });

  return (
    <div className={classes}>
      <h3 className="content-block__heading">{title}</h3>
      {subtitle && <p className="content-block__subheading">{subtitle}</p>}
      <div className="content-block__content">{children}</div>
    </div>
  );
};

export default ContentBlock;
